import { SubmitButton } from '@/app/pages/family_application/student_details/shared/submit-button'
import { MutationStatus } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { Button, buttonVariants } from '../Button'
import { Card, CardContent, CardHeader } from '../Card'
import UploadedFilePreview from './uploaded_file_preview'
import { ImagePathPreview } from './image_path_preview'

interface Props {
  onRemove: (index: number) => void
  files: File[]
  onUploadMoreDocsClick: () => void
  onUploadDocumentsClick: () => void
  uploadStatus: MutationStatus
  uploadedDocuments: string[]
  onUploadedDocumentRemove: (index: number) => void
}

function UploadedFileSelection(props: Props) {
  const { onRemove, files, onUploadMoreDocsClick, onUploadDocumentsClick, uploadStatus, uploadedDocuments, onUploadedDocumentRemove } = props
  const { t } = useTranslation()


  return (
    <Card className="document-gallery">
      <CardHeader className="font-medium">{files.length + uploadedDocuments.length} {t('uploaded_documents')}</CardHeader>
      <CardContent className='w-full'>
        <div className="space-y-4">
          {
            uploadedDocuments.map((path, index) => {
              return (
                <ImagePathPreview
                title={`Document ${index + 1}`}
                onRemove={() => {
                  onUploadedDocumentRemove(index)
                }} index={index} path={path} />
              )
            })
          }
          {files?.map((doc, index) => (
            <UploadedFilePreview
              title={`Document ${uploadedDocuments.length + (index + 1)}`}
              file={doc} index={index}
              onRemove={onRemove}
              t={t}
            />
          ))}
        </div>
        <div className="flex items-center justify-center mt-10 space-x-2">
          <div>
            <Button
              variant={'outline'}
              onClick={() => {
                onUploadMoreDocsClick()
              }}
            >
              {t('upload_more_documents')}
            </Button>
          </div>
          <div>
            <SubmitButton
              status={uploadStatus}
              className={buttonVariants({
                variant: 'primary',
              })}
              onClick={onUploadDocumentsClick}
              buttonTxt={t('upload_documents')}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default UploadedFileSelection
